import * as constant from "./constant";

const INITIAL_STATE = {
  loading: false,
  avatarGetResponse: {
    data: [],
    httpStatus: 0,
  },
  avatarsGetResponse: {
    data: {},
    httpStatus: 0,
  },
  avatarCreateResponse: {
    data: {},
    httpStatus: 0,
  },
  avatarSwapResponse: {
    data: {},
    httpStatus: 0,
  },
};

const avatarReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case constant.LOADING:
      return Object.assign({}, state, {
        loading: action.payload,
      });
    case constant.GET_AVATAR_RESPONSE:
      return Object.assign({}, state, {
        avatarGetResponse: action.payload,
      });
    case constant.GET_AVATARS_RESPONSE:
      return Object.assign({}, state, {
        avatarsGetResponse: action.payload,
      });
    case constant.CREATE_AVATAR_RESPONSE:
      return Object.assign({}, state, {
        avatarCreateResponse: action.payload,
      });
    case constant.SWAP_AVATAR_RESPONSE:
      return Object.assign({}, state, {
        avatarSwapResponse: action.payload,
      });
    default:
      return state;
  }
};

export default avatarReducer;
